/**
 * Whether the page's own Permissions-Policy (the server's response header) turns a browser feature off for this site. When it
 * does, the browser refuses the feature whatever the learner allowed, so the per-browser "how to allow it" steps cannot help.
 *
 * Chrome and Edge expose the policy (`document.permissionsPolicy`, older `document.featurePolicy`); Safari and Firefox do not,
 * so there this always answers false and the usual steps stay. Server-side (no `document`) it is false too.
 */
type TPolicyReader = { allowsFeature?: (feature: string) => boolean };

export const isTurnedOffBySitePolicy = (feature: "geolocation" | "camera"): boolean => {
  if (typeof document === "undefined") return false;
  const doc = document as Document & { permissionsPolicy?: TPolicyReader; featurePolicy?: TPolicyReader };
  const policy = doc.permissionsPolicy ?? doc.featurePolicy;
  if (typeof policy?.allowsFeature !== "function") return false;
  try {
    return policy.allowsFeature(feature) === false;
  } catch {
    return false;
  }
};

/** Shown instead of the browser steps when the site itself turns location off: nothing on the learner's device can change it. */
export const SITE_LOCATION_OFF_TITLE = "Location is turned off for this site";
